// Login social via Cognito Hosted UI (identity_provider = nome do provider no Cognito)

const PENDING_KEY = "socialLoginPending";

// Erro do Cognito no primeiro login de um provider recém-vinculado a uma conta
// existente (Lambda PreSignUp de account linking). Tentar de novo resolve.
const LINKED_ACCOUNT_ERROR = /already found an entry for username/i;

export const signinWithProvider = (auth, provider, state) => {
  sessionStorage.setItem(PENDING_KEY, JSON.stringify({ provider, state, retried: false }));
  return auth.signinRedirect({
    extraQueryParams: {
      identity_provider: provider,
      // Força o Google a sempre exibir o seletor de conta
      ...(provider === "Google" && { prompt: "select_account" }),
    },
    ...(state && { state }),
  });
};

// Retorna true quando refez o login (uma única vez) após o erro de conta vinculada
export const retryLinkedAccountSignin = (auth, error) => {
  if (!LINKED_ACCOUNT_ERROR.test(error?.message || "")) return false;

  const pending = JSON.parse(sessionStorage.getItem(PENDING_KEY) || "null");
  if (!pending || pending.retried) return false;

  sessionStorage.setItem(PENDING_KEY, JSON.stringify({ ...pending, retried: true }));
  auth.signinRedirect({
    extraQueryParams: { identity_provider: pending.provider },
    ...(pending.state && { state: pending.state }),
  });
  return true;
};

// returnTo vem do state do OIDC: aceita apenas paths relativos
export const getSafeReturnPath = (returnTo) =>
  typeof returnTo === "string" && returnTo.startsWith("/") && !returnTo.startsWith("//")
    ? returnTo
    : null;
